import { SET_HAS_FAMILY_STRUCTURE } from '../actions/hasFamilyStructureDataActions';

let initialState = false;

const hasFamilyStructureDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_FAMILY_STRUCTURE:
            return action.payload.value
        default:
            return state;
    }
}

export default hasFamilyStructureDataReducer;